"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.LivePlayerType = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactPlayerLoader = _interopRequireDefault(require("@brightcove/react-player-loader"));

var _VideoOverlay = _interopRequireWildcard(require("./VideoOverlay"));

var _LivePlayer = require("./LivePlayer.style");

var LivePlayerType = {
  embed: 'embed',
  brightcove: 'brightcove'
}; // For the Brightcove Player the URL prop MUST contain only the videoId, ex. 6258950085001

exports.LivePlayerType = LivePlayerType;

function VideoEmbed(_ref) {
  var hasVotemo = _ref.hasVotemo,
      overlay = _ref.overlay,
      splitLogic = _ref.splitLogic,
      type = _ref.type,
      url = _ref.url;
  return /*#__PURE__*/_react.default.createElement(_LivePlayer.StyledPlayer, {
    splitSize: splitLogic,
    hasVotemo: hasVotemo
  }, overlay && /*#__PURE__*/_react.default.createElement(_VideoOverlay.default, overlay), type === 'brightcove' ? /*#__PURE__*/_react.default.createElement(_LivePlayer.BrightCoveContainer, null, /*#__PURE__*/_react.default.createElement(_reactPlayerLoader.default, {
    style: {
      width: '100%',
      height: '100%'
    },
    accountId: "6253422315001",
    playerId: "HFV4L2yaX",
    videoId: url
  })) : /*#__PURE__*/_react.default.createElement("iframe", {
    title: "Live Feed",
    width: "100%",
    height: "100%",
    src: url,
    frameBorder: "0",
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true
  }));
}

VideoEmbed.propTypes = {
  hasVotemo: _propTypes.default.bool,
  type: _propTypes.default.oneOf(Object.values(LivePlayerType)),
  overlay: _propTypes.default.shape(_VideoOverlay.videoEmbedOverlayProps),
  splitLogic: _propTypes.default.bool,
  url: _propTypes.default.string.isRequired
};
VideoEmbed.defaultProps = {
  hasVotemo: false,
  overlay: null,
  type: LivePlayerType.embed,
  splitLogic: false
};
var _default = VideoEmbed;
exports.default = _default;